import Vue from 'vue';
import VueRouter from 'vue-router';
import Branding from '@/views/Branding';
import ContactManagement from '@/views/ContactManagement/ContactManagement';
import EmailSignatures from '@/views/EmailSignatures';
import Summary from '@/views/Summary';
import SmsProvisioning from '@/views/SMS/SmsProvisioning';
import Behaviours from '@/views/Behaviours/Behaviours';
import Resources from '@/views/Resources/Resources';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/summary'
  },
  {
    path: '/summary',
    name: 'Summary',
    component: Summary
  },
  {
    path: '/branding',
    name: 'Branding',
    component: Branding
  },
  {
    path: '/templates',
    name: 'Templates',
    component: EmailSignatures
  },
  {
    path: '/behaviours',
    name: 'Behaviours',
    component: Behaviours
  },
  {
    path: '/resources',
    name: 'Resources',
    component: Resources
  },
  {
    path: '/contact-management',
    name: 'ContactManagement',
    component: ContactManagement
  },
  {
    path: '/sms-provisioning',
    name: 'SmsProvisioning',
    component: SmsProvisioning
  },
  {
    path: '/*',
    redirect: '/branding'
  }
];

const router = new VueRouter({
  routes
});

export default router;
